import ContentDetailPageHeader from "../components/common/content/content-detail-page-header";
import ContentHeader from "../components/common/content/content-header";
import { StyledContainer } from "../components/common/content/styles";
import { Typography } from "@mui/material";
import {Seo} from "../seo/Seo";

export default function ContactUs() {
  return (
    <>
      <Seo
        title="Contact Us"
        description="Contact St. George Coptic Orthodox Church in Monee, IL for services, sacraments, and ministries."
        path="/contact-us"
      />
      <StyledContainer maxWidth={false}>
        <ContentDetailPageHeader />
        <ContentHeader title="Contact Us" />
        <Typography
          color="text.primary"
          variant="body1"
          fontWeight="bold"
          textAlign={"center"}
        >
          Viber link to come, please check back later.
        </Typography>
      </StyledContainer>
    </>
  );
}
